import { EmptyStateView } from '../components/EmptyStateView';
import { useHomePageEmptyState } from '../components/EmptyStateView/useHomePageEmptyState';
import { Header } from '../components/Header';
import { useDisabledPageView } from '../hooks/useDisabledPageView';

import { StyledContainer } from './styles';

export const HomePage = () => {
  const { isDisabledPageVisible, disabledPageView } = useDisabledPageView();
  const homePageConfig = useHomePageEmptyState();

  if (isDisabledPageVisible) {
    return disabledPageView;
  }

  return (
    <>
      <Header />
      <StyledContainer data-automation="HomePage">
        <EmptyStateView
          textKey={homePageConfig?.textKey}
          messageKey={homePageConfig?.messageKey}
          img={homePageConfig?.img}
          variant={homePageConfig?.variant}
        />
      </StyledContainer>
    </>
  );
};
